import { __rest } from "tslib";
import * as React from 'react';
import { BaseColorPicker } from './BaseColorPicker';
import { StylesConsumer } from '../../contexts/StylesContext';
import { SDKAdapterConsumer } from '../../contexts/SDKAdapterContext';
export var ColorPicker = function (_a) {
    var title = _a.title, value = _a.value, onChange = _a.onChange, props = __rest(_a, ["title", "value", "onChange"]);
    return (React.createElement(SDKAdapterConsumer, null, function (_a) {
        var SDKAdapter = _a.SDKAdapter;
        return (React.createElement(StylesConsumer, null, function (styles) {
            return (React.createElement(BaseColorPicker, { label: title, value: value, onChange: onChange, SDKAdapter: SDKAdapter, onSiteColorsChange: function (palette) {
                    styles.changeSiteColors(palette);
                }, dataHook: props.dataHook }));
        }));
    }));
};
//# sourceMappingURL=ColorPicker.js.map